import axiosInstance from "./authWrapper";

export const createSkorTicket = async ({ attachments = [], ...ticket }) => {
  const formData = new FormData();
  Object.entries(ticket).forEach(([field, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(
        field,
        Array.isArray(value) ? JSON.stringify(value) : value
      );
    }
  });
  attachments.forEach((file) => formData.append("attachments", file));
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_SERVER_URL}/skor-tickets`,
    formData,
    { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
  );
  if (!response.data?.success) throw new Error("Ticket creation failed");
  const createdTicket = response.data?.success_res?.ticket;
  if (!createdTicket) throw new Error("Ticket creation failed");
  return createdTicket;
};
